import { useUploadAssetsContext } from 'modules/creativeLibrary/contexts/UploadAssetsContext';
import { Asset, PromiseStatus } from 'modules/creativeLibrary/types';
import { isValidPendingAsset } from 'modules/creativeLibrary/utils/images';
import styled from 'styled-components';
import { TakeoverDetailImage } from '../../index/takeover/TakeoverDetailImage';
import { InputImageName } from '../../index/details/InputImageName';
import { InputImageURL } from '../../index/details/InputImageURL';
import { FileDetails } from '../../index/details/FileDetails';
import { SpecialSection } from '../../index/details/Styled';
import { AltTextInput } from '../../common';

const ScrollableContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.backgroundColors.backgroundSecondary};
  flex: 1 1 auto;
  overflow: auto;
`;

const Details = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing.values.base};
  row-gap: ${({ theme }) => theme.spacing.values.plusHalf};
`;

const ImageSection = styled(SpecialSection)`
  align-items: center;
  height: ${({ theme }) => theme.spacing.utils.pxToRem(328)};
  justify-content: center;
  padding: 20px;
  row-gap: ${({ theme }) => theme.spacing.values.plusHalf};
`;

export const testIds = {
  sectAltText: 'cl-index-takeover-detail-alt-txt-section',
  sectFile: 'cl-index-takeover-detail-file-section',
  sectImage: 'cl-index-takeover-detail-image-section',
  sectLabels: 'cl-index-takeover-detail-labels-section',
  sectName: 'cl-index-takeover-detail-name-section',
  sectUrl: 'cl-index-takeover-detail-url-section',
};

export const UploadDetail = () => {
  const { onModifyPendingAssets, pendingImages } = useUploadAssetsContext();

  const editableSelected = pendingImages.filter((pi) => {
    if (!pi.isSelected) return false;
    if (pi.processStatus === PromiseStatus.Rejected || pi.uploadStatus === PromiseStatus.Rejected) {
      return true;
    }
    return isValidPendingAsset(pi);
  });

  const showSingleSelectionSections =
    editableSelected.length === 1 &&
    editableSelected[0].processStatus !== PromiseStatus.Rejected &&
    editableSelected[0].uploadStatus !== PromiseStatus.Rejected;

  return (
    <ScrollableContainer>
      <Details>
        <ImageSection data-test={testIds.sectImage}>
          <TakeoverDetailImage selectedAssets={editableSelected} />
        </ImageSection>
        {showSingleSelectionSections && (
          <>
            <section data-test={testIds.sectName}>
              <InputImageName
                onChange={(name: string) =>
                  onModifyPendingAssets([editableSelected[0].id], { name })
                }
                value={editableSelected[0].file?.name || ''}
              />
            </section>
            <section data-test={testIds.sectAltText}>
              <AltTextInput
                value={editableSelected[0].file?.altText || ''}
                onChange={(value: string) =>
                  onModifyPendingAssets([editableSelected[0].id], { altText: value })
                }
                showDescription
              />
            </section>
            {editableSelected[0].asset && (
              <section data-test={testIds.sectUrl}>
                <InputImageURL value={editableSelected[0].asset?.url || ''} />
              </section>
            )}
            <FileDetails
              asset={
                editableSelected[0].asset ||
                ({
                  height: editableSelected[0].file?.height,
                  mimeType: editableSelected[0].file?.mimeType,
                  size: editableSelected[0].file?.size,
                  width: editableSelected[0].file?.width,
                } as Asset)
              }
              data-test={testIds.sectFile}
            />
          </>
        )}
      </Details>
    </ScrollableContainer>
  );
};
